/* pdp-single.js — shared PDP for SINGLE-design prefixes (ink + color + size, no design selector).
   Theme asset (Horizon-safe). Reads #pdp-cfg. Embedded variantData (no fetch). Server-rendered image.
   Shimmer overlay -> fade reveal transition. */
(function () {
  var cfgEl = document.getElementById('pdp-cfg');
  if (!cfgEl) return;
  var CFG = JSON.parse(cfgEl.textContent);
  (function(){ function _hb(){ var b=document.getElementById('pdp-boot'); var w=document.querySelector('.pdp-wrap');
    if(w) w.classList.add('pdp-ready'); if(b){ b.style.opacity='0'; b.style.pointerEvents='none'; setTimeout(function(){ if(b) b.style.display='none'; },350); } }
    if(document.readyState==='complete'){ setTimeout(_hb,50); } else { window.addEventListener('load', function(){ setTimeout(_hb,50); }); }
    setTimeout(_hb, 1500); /* FORCE_HIDE_BOOT hard fallback */ })();
  var REVEAL_MS = 350;
  var _bootStart = Date.now();
  function reveal() {
    var wrap = document.querySelector('.pdp-wrap');
    var boot = document.getElementById('pdp-boot');
    if (wrap) wrap.classList.add('pdp-ready');
    if (boot) { boot.classList.add('pdp-boot-hide'); setTimeout(function () { boot.style.display = 'none'; }, 320); }
  }
  function scheduleReveal() { reveal(); }

  var DATA = { tee: null, hoodie: null };
  var g = 'tee', color = CFG.defaultColor, ink = CFG.inks[0], size = null;
  var colorChosen = false, inkChosen = false;
  var QV = (function () { try { var v = new URLSearchParams(location.search).get('variant'); return v ? parseInt(v, 10) : null; } catch (e) { return null; } })();
  function el(id) { return document.getElementById(id); }
  function prod() { return DATA[g]; }
  function vars() { return prod() ? prod().variants : []; }
  function colorsOf() { return CFG.colorOrder.filter(function (c) { return vars().some(function (v) { return v.color === c; }); }); }
  function inksFor(c) { return CFG.TV[c] || []; }
  function inkEnabled(t) { var cc = colorChosen ? [color] : colorsOf(); return cc.some(function (c) { return inksFor(c).indexOf(t) >= 0; }); }
  function colorEnabled(c) { if (inkChosen) return inksFor(c).indexOf(ink) >= 0; return inksFor(c).length > 0; }
  function effColor() { return colorsOf().indexOf(color) >= 0 ? color : colorsOf()[0]; }
  function effInk() { var vi = inksFor(effColor()); return vi.indexOf(ink) >= 0 ? ink : vi[0]; }
  function imgUrl(gar, c, t) { return CFG.img[gar + '|' + CFG.design + '|' + c + '|' + t] || ''; }
  function setImg() { var u = imgUrl(g, effColor(), effInk()); if (u) el('pdp-hero').src = u; }

  function renderInk() {
    var r = el('pdp-inkrow'); r.innerHTML = '';
    CFG.inks.forEach(function (t) {
      var b = document.createElement('button'); b.type = 'button'; var ok = inksFor(effColor()).indexOf(t) >= 0;
      b.className = 'pdp-inkbtn' + (t === effInk() && ok ? ' on' : '') + (ok ? '' : ' dis');
      b.innerHTML = '<span class="pdp-tdot" style="background:' + CFG.inkDot[t] + '"></span>' + CFG.inkLabel[t];
      b.disabled = !ok; if (ok) b.onclick = function () { ink = t; inkChosen = true; sync(); };
      r.appendChild(b);
    });
    el('pdp-inkname').textContent = '\u2014 ' + CFG.inkLabel[effInk()];
  }
  function renderColors() {
    var r = el('pdp-sw'); r.innerHTML = '';
    CFG.colorOrder.forEach(function (c) {
      var b = document.createElement('button'); b.type = 'button'; b.style.background = CFG.hex[c] || '#ccc';
      if ((CFG.hex[c] || '').toLowerCase() === '#ffffff') b.style.borderColor = '#999';
      var ok = colorEnabled(c) && colorsOf().indexOf(c) >= 0; b.className = (c === effColor() && ok ? 'on' : '') + (ok ? '' : ' dis'); b.disabled = !ok; b.title = c;
      if (ok) b.onclick = function () { color = c; colorChosen = true; sync(); };
      r.appendChild(b);
    });
    el('pdp-colname').textContent = '\u2014 ' + effColor();
  }
  function sizesFor() { return vars().filter(function (v) { return v.color === effColor(); }).sort(function (a, b) { return CFG.sizeOrder.indexOf(a.size) - CFG.sizeOrder.indexOf(b.size); }); }
  function renderSizes() {
    var r = el('pdp-sz'); r.innerHTML = '';
    sizesFor().forEach(function (v) {
      var b = document.createElement('button'); b.type = 'button'; b.textContent = v.size; b.disabled = !v.available;
      b.className = (v.size === size ? 'on' : ''); b.onclick = function () { size = v.size; syncSize(); };
      r.appendChild(b);
    });
  }
  function curV() { if (!size) return null; return vars().find(function (v) { return v.color === effColor() && v.size === size; }); }
  function syncSize() {
    renderSizes(); var v = curV(); var a = el('pdp-atc');
    if (v) {
      a.textContent = 'Add to cart \u2014 $' + v.price;
      a.onclick = function () {
        a.textContent = 'Adding\u2026';
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: v.vid, quantity: 1, properties: { Ink: (CFG.inkLabel[effInk()] || '') } }) })
          .then(function () { a.textContent = 'Added \u2713'; return fetch('/cart.js'); })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var evt = new Event('cart:update', { bubbles: true });
            evt.detail = { resource: cart, sourceId: 'ad-pdp-atc', data: { source: 'product-form-component', itemCount: cart.item_count } };
            document.dispatchEvent(evt);
            var dr = document.querySelector('cart-drawer-component'); if (dr && typeof dr.open === 'function') { try { dr.open(); } catch (e) {} }
            setTimeout(syncSize, 1200);
          }).catch(function () { a.textContent = 'Added \u2713'; setTimeout(syncSize, 1500); });
      };
    } else { a.textContent = 'Select a size'; a.onclick = null; }
  }
  function sync() {
    setImg(); renderInk(); renderColors();
    var vs = vars(); if (vs.length) {
      var mn = Math.min.apply(null, vs.map(function (v) { return parseFloat(v.price); }));
      var mv = vs.filter(function (v) { return parseFloat(v.price) === mn; })[0]; var c = mv && mv.compare ? mv.compare : null;
      el('pdp-price').innerHTML = (c ? '<s>$' + c + '</s>' : '') + '<span>$' + mn.toFixed(2) + '</span>' + (c ? '<span class="pdp-off">20% OFF</span>' : '');
    }
    var keep = size && sizesFor().some(function (v) { return v.size === size && v.available; }); if (!keep) size = null;
    syncSize(); prefetchNear();
  }
  var _pf = {};
  function prefetchNear() { inksFor(effColor()).forEach(function (t) { warm(imgUrl(g, effColor(), t)); }); warm(imgUrl(g === 'tee' ? 'hoodie' : 'tee', effColor(), effInk())); }
  function warm(u) { if (!u || _pf[u]) return; _pf[u] = 1; var im = new Image(); im.decoding = 'async'; if ('fetchPriority' in im) im.fetchPriority = 'low'; im.src = u; }

  function garment(x) { g = x; el('pdp-gtee').className = (x === 'tee' ? 'on' : ''); el('pdp-ghood').className = (x === 'hoodie' ? 'on' : ''); ensure(g, function () { if (colorsOf().indexOf(color) < 0) color = colorsOf()[0]; sync(); }); }
  function resetPDP() { color = CFG.defaultColor; ink = CFG.inks[0]; size = null; colorChosen = false; inkChosen = false; garment('tee'); }
  function ensure(gar, cb) {
    if (DATA[gar]) { cb(); return; }
    if (CFG.variantData && CFG.variantData[gar] && CFG.variantData[gar].variants) { DATA[gar] = { variants: CFG.variantData[gar].variants }; cb(); return; }
    var h = CFG.handles[gar]; if (!h) { cb(); return; }
    fetch('/products/' + h + '.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (j) {
      DATA[gar] = { variants: (j.variants || []).map(function (v) { return { color: v.option1, size: v.option2, available: v.available, vid: v.id, price: (v.price / 100).toFixed(2), compare: (v.compare_at_price ? (v.compare_at_price / 100).toFixed(2) : null) }; }) }; cb();
    }).catch(function () { cb(); });
  }
  function wire() {
    el('pdp-gtee').onclick = function () { garment('tee'); };
    el('pdp-ghood').onclick = function () { garment('hoodie'); };
    el('pdp-reset').onclick = resetPDP;
    el('pdp-stage').addEventListener('click', function () { el('pdp-zoomimg').src = el('pdp-hero').src; el('pdp-zoom').classList.add('on'); });
    el('pdp-zoom').addEventListener('click', function () { el('pdp-zoom').classList.remove('on'); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') el('pdp-zoom').classList.remove('on'); });
    ensure('tee', function () {
      if (prod() && QV) { var qv = prod().variants.find(function (v) { return v.vid === QV; }); if (qv) { color = qv.color; } }
      if (prod()) { if (colorsOf().indexOf(color) < 0) color = colorsOf()[0]; }
      el('pdp-gtee').className = 'on'; sync(); scheduleReveal();
      setTimeout(warmAll, 200);
    });
    ensure('hoodie', function () {});
  }

  // Background-warm all combo images (decode into cache) so option swaps are instant.
  function warmAll() {
    try {
      if (!CFG.img) return;
      var urls = [], seen = {};
      Object.keys(CFG.img).forEach(function (k) {
        var u = CFG.img[k]; if (!u || seen[u]) return; seen[u] = 1;
        urls.push({ u: u, pri: (k.split('|')[0] === g) ? 0 : 1 });
      });
      urls.sort(function (a, b) { return a.pri - b.pri; });
      var i = 0;
      function next() {
        if (i >= urls.length) return;
        var batch = urls.slice(i, i + 4); i += 4;
        var pending = batch.length;
        batch.forEach(function (o) {
          var im = new Image();
          im.onload = im.onerror = function () { if (--pending <= 0) setTimeout(next, 60); };
          im.src = o.u;
          if (im.decode) { im.decode().catch(function () {}); }
        });
      }
      next();
    } catch (e) {}
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', wire); else wire();
})();
